<template>
  <div class="main-content-container full-bg">
    <b-row>
      <b-col xl="6" lg="9" md="9">
        <div
          class="top-content-container edit-pa-profile position-relative mb-5"
        >
          <b-breadcrumb class="position-relative ml-3 pb-2" style="right: 1rem">
            <b-breadcrumb-item>
              <span
                @click="navigateToCustomers"
                class="text-uppercase font-family-medium"
              >
                Customers
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              <span class="text-uppercase font-family-medium">
                {{ customerFullname }}
              </span>
            </b-breadcrumb-item>
          </b-breadcrumb>
          <!-- Skeleton loader customer -->
          <b-row class="d-flex mx-0 my-4" v-if="isLoadingCustomer">
            <b-skeleton type="avatar" size="8rem"></b-skeleton>
            <div
              style="width: 20rem"
              class="
                d-flex
                flex-column
                position-relative
                justify-content-center
                px-0
                ml-4
              "
            >
              <b-skeleton width="100%" class="mb-3"></b-skeleton>
              <b-skeleton width="75%" class="mb-3"></b-skeleton>
              <div class="d-flex">
                <b-skeleton width="50%"></b-skeleton>
              </div>
            </div>
          </b-row>
          <!-- End skeleton loader -->
          <b-row class="d-flex mx-0 my-4" v-else>
            <b-avatar
              class=""
              size="8rem"
              v-if="avatar"
              :src="avatar"
            ></b-avatar>
            <b-avatar
              v-else
              size="8rem"
              :text="customerInitials"
              class="bg--primary"
            ></b-avatar>
            <div class="d-flex flex-column position-relative px-0 ml-4">
              <p class="font-family-medium primary--text">
                {{ customerFullname }}
              </p>
              <div class="d-flex" v-if="membership">
                <b-button
                  class="
                    text-uppercase
                    reduce-whitespace-2
                    mr-2
                    btn-chip
                    btn-danger--light
                    danger
                    font-family-regular
                    btn-chip--pill
                  "
                  >{{ membership.title }}</b-button
                >
              </div>
            </div>
          </b-row>
        </div>
        <b-tabs
          class="mt-5"
          style="width: 97%"
          active-nav-item-class="danger"
          active-tab-class="font-weight-bold"
          content-class="mt-3"
        >
          <b-tab class="mb-2" title="Preferences">
            <ValidationObserver ref="observer">
              <b-form class="mt-5">
                <b-form-group
                  style="margin-top: 5rem"
                  class="d-flex font-family-regular primary-dark mb-5"
                >
                  <b-card class="d-flex flex-column general-info-card">
                    <div class="d-flex flex-wrap">
                      <b-row class="w-100 my-0 mx-auto">
                        <b-col class="mb-4">
                          <ValidationProvider
                            name="Name field"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-group label="Name">
                              <b-form-input
                                autocomplete="off"
                                size="lg"
                                type="text"
                                placeholder
                                v-model="customerFullname"
                                disabled
                              ></b-form-input>
                              <h6
                                class="
                                  font-sm
                                  mb-3
                                  mt-2
                                  font-family-regular
                                  position-absolute
                                  danger
                                "
                              >
                                {{ errors[0] }}
                              </h6>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row class="w-100 my-0 mx-auto">
                        <b-col class="mb-4">
                          <ValidationProvider
                            name="Phone Number field"
                            rules
                            v-slot="{ errors }"
                          >
                            <b-form-group label="Phone Number">
                              <b-form-input
                                autocomplete="off"
                                size="lg"
                                type="text"
                                v-model="phone"
                                disabled
                                placeholder
                              ></b-form-input>
                              <h6
                                class="
                                  font-sm
                                  mb-3
                                  mt-2
                                  font-family-regular
                                  position-absolute
                                  danger
                                "
                              >
                                {{ errors[0] }}
                              </h6>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row class="w-100 my-0 mx-auto">
                        <b-col class="mb-4">
                          <ValidationProvider
                            name="Role field"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-group label="Role">
                              <b-form-input
                                autocomplete="off"
                                size="lg"
                                disabled
                                v-model="customerRole"
                                type="text"
                                placeholder
                              ></b-form-input>
                              <h6
                                class="
                                  font-sm
                                  mb-3
                                  mt-2
                                  font-family-regular
                                  position-absolute
                                  danger
                                "
                              >
                                {{ errors[0] }}
                              </h6>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row class="w-100 mb-4 mx-auto">
                        <b-col class="mb-4">
                          <ValidationProvider
                            name="Time zone field"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-group label="Timezone">
                              <b-form-input
                                disabled
                                v-model="selectedTimeZone"
                              ></b-form-input>
                              <h6
                                class="
                                  font-sm
                                  mb-3
                                  mt-2
                                  font-family-regular
                                  position-absolute
                                  danger
                                "
                              >
                                {{ errors[0] }}
                              </h6>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row class="w-100 mb-4 mx-auto">
                        <b-col class="mb-4">
                          <ValidationProvider
                            name="Public Support Billing Entity"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-group label="Public Support Billing Entity">
                              <b-form-select
                                disabled
                                :options="billingEntities"
                                v-model="billingEntity"
                                class="primary--text font-size-md"
                              ></b-form-select>
                              <h6
                                class="
                                  font-sm
                                  mb-3
                                  mt-2
                                  font-family-regular
                                  position-absolute
                                  danger
                                "
                              >
                                {{ errors[0] }}
                              </h6>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row class="w-100 mb-4 mx-auto">
                        <b-col class="mb-4">
                          <ValidationProvider
                            name="Language field"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-group label="Language">
                              <b-form-input
                                autocomplete="off"
                                size="lg"
                                disabled
                                type="text"
                                v-model="language"
                              ></b-form-input>
                              <h6
                                class="
                                  font-sm
                                  mb-3
                                  mt-2
                                  font-family-regular
                                  position-absolute
                                  danger
                                "
                              >
                                {{ errors[0] }}
                              </h6>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row class="w-100 my-0 mx-auto">
                        <b-col class="mb-4">
                          <ValidationProvider
                            name="Linkedin field"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-group label="Linkedin">
                              <b-form-input
                                autocomplete="off"
                                disabled
                                size="lg"
                                type="text"
                                placeholder
                                v-model="linkedin"
                              ></b-form-input>
                              <h6
                                class="
                                  font-sm
                                  mb-3
                                  mt-2
                                  font-family-regular
                                  position-absolute
                                  danger
                                "
                              >
                                {{ errors[0] }}
                              </h6>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row class="w-100 my-0 mx-auto">
                        <b-col class="mb-4">
                          <ValidationProvider
                            name="Infrastructure field"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-group
                              label="Infrastructure: Outlook, Gmail, Slack etc..."
                            >
                              <b-form-input
                                autocomplete="off"
                                size="lg"
                                v-model="infrastructure"
                                type="text"
                                placeholder
                                disabled
                              ></b-form-input>
                              <h6
                                class="
                                  font-sm
                                  mb-3
                                  mt-2
                                  font-family-regular
                                  position-absolute
                                  danger
                                "
                              >
                                {{ errors[0] }}
                              </h6>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row class="w-100 mb-4 mx-auto">
                        <b-col class="mb-4">
                          <ValidationProvider
                            name="Subscription Plan field"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-group
                              label="Subscription plan"
                              v-if="membership"
                            >
                              <b-form-input
                                class="text-capitalize"
                                v-model="membership.title"
                                disabled
                              ></b-form-input>
                              <h6
                                class="
                                  font-sm
                                  mb-3
                                  mt-2
                                  font-family-regular
                                  position-absolute
                                  danger
                                "
                              >
                                {{ errors[0] }}
                              </h6>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row class="w-100 mb-4 mx-auto">
                        <b-col class="mb-4">
                          <ValidationProvider
                            name="subscriptionHours"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-group label="Subscription hours per month">
                              <b-form-input
                                class="text-capitalize"
                                v-model="membershipHours"
                                disabled
                              ></b-form-input>
                              <h6
                                class="
                                  font-sm
                                  mb-3
                                  mt-2
                                  font-family-regular
                                  position-absolute
                                  danger
                                "
                              >
                                {{ errors[0] }}
                              </h6>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row class="w-100 mb-4 mx-auto">
                        <b-col class="mb-4">
                          <ValidationProvider
                            name="Profile type field"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-group label="Profile type">
                              <b-form-input
                                disabled
                                v-model="selectedProfileType"
                              ></b-form-input>
                              <h6
                                class="
                                  font-sm
                                  mb-3
                                  mt-2
                                  font-family-regular
                                  position-absolute
                                  danger
                                "
                              >
                                {{ errors[0] }}
                              </h6>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row class="w-100 mx-auto">
                        <b-col class="mb-4">
                          <ValidationProvider
                            name="Deepdive date field"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-group label="Deepdive date">
                              <b-input-group class="mb-3">
                                <b-form-input
                                  v-model="startDate"
                                  type="text"
                                  disabled
                                  placeholder="YYYY-MM-DD"
                                  autocomplete="off"
                                ></b-form-input>
                              </b-input-group>
                              <h6
                                class="
                                  font-sm
                                  mb-3
                                  mt-2
                                  font-family-regular
                                  position-absolute
                                  danger
                                "
                              >
                                {{ errors[0] }}
                              </h6>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <div class="questions-list w-100">
                        <b-row
                          class="w-100 my-0 mx-auto"
                          v-for="question in questions"
                          :key="question.id"
                        >
                          <b-col>
                            <b-form-group
                              :label="question.formQuestion.question.title"
                            >
                              <b-form-textarea
                                autocomplete="off"
                                size="lg"
                                type="text"
                                disabled
                                :value="question.answer.answer"
                                placeholder
                              ></b-form-textarea>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </b-card>
                </b-form-group>
              </b-form>
            </ValidationObserver>
            <!-- <b-button class="btn-danger btn-pill px-5 py-3 mt-5">Save</b-button> -->
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col md="9" xl="6" lg="9">
        <h4
          v-if="assistantsList.length > 0"
          class="font-md font-family-medium primary-dark mb-5"
        >
          Select EA to assign
        </h4>
        <div
          class="
            no-assigned-msg
            pt-5
            pb-5
            d-flex
            flex-column
            justify-content-center
            align-items-center
          "
          v-if="assistantsList.length === 0 && !isLoadingAssistants"
        >
          <h4 class="font-md primary--text font-family-medium">
            No assistants found.
          </h4>
        </div>
        <!-- Show assistants skeleton loader -->
        <div class="d-flex mb-5" v-if="isLoadingAssistants">
          <b-card class="d-flex flex-column general-info-card mb-5">
            <div class="d-flex flex-wrap mt-5">
              <b-card
                v-for="(assistant, index) in 6"
                :key="index"
                class="overflow-hidden w-100 mb-2"
              >
                <b-row class="w-100 mx-auto mb-3" align-v="center">
                  <b-col md="4">
                    <b-row align-v="center">
                      <b-col class="d-flex position-relative px-0" md="3">
                        <b-skeleton type="avatar" size="4rem"></b-skeleton>
                      </b-col>
                      <b-col class="position-relative px-0 ml-3">
                        <b-skeleton></b-skeleton>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="4" class="justify-content-left">
                    <b-skeleton></b-skeleton>
                    <b-skeleton></b-skeleton>
                  </b-col>
                  <b-col md="2" class="justify-content-left">
                    <b-skeleton></b-skeleton>
                  </b-col>
                  <b-col
                    md="2"
                    style="left: 2rem"
                    class="position-relative justify-content-center d-flex"
                  >
                    <b-skeleton type="avatar" size="3rem"></b-skeleton>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </b-card>
        </div>
        <!-- End assistants skeleton loader -->
        <div
          class="d-flex font-family-regular primary-dark mb-5"
          v-if="assistantsList.length > 0 && !isLoadingAssistants"
        >
          <b-card class="d-flex flex-column general-info-card">
            <div class="d-flex flex-wrap px-3">
              <b-row class="w-100 mx-auto mb-3">
                <b-col md="4" class="px-0">
                  <h6 class="font-sm primary--text font-family-medium ml-2">
                    EA name
                  </h6>
                </b-col>
                <b-col md="4">
                  <h6 class="font-sm primary--text font-family-medium">
                    Capacity
                  </h6>
                </b-col>
                <b-col md="2">
                  <h6
                    class="
                    font-sm primary--text 
                    font-family-medium 
                    reduce-line-height 
                    text-center
                    "
                  >
                    Job title
                  </h6>
                </b-col>
                <b-col md="2" class="position-relative" style="left: 1.5rem">
                  <h6 class="font-sm primary--text font-family-medium">
                    Assign
                  </h6>
                </b-col>
              </b-row>
              <b-row
                style="border-radius: 6px"
                class="
                  border-primary-lighter
                  px-2
                  bg--light
                  pt-2
                  d-flex
                  flex-column flex-wrap
                  w-100
                  mx-auto
                  mb-2
                "
              >
                <b-card
                  v-for="(assistant, index) in assistantsList"
                  :key="assistant.id"
                  class="cy-assign-pa-list overflow-hidden w-100 mb-2"
                >
                  <b-row class="w-100 mx-auto mb-3" align-v="center">
                    <b-col md="4">
                      <b-row align-v="center">
                        <b-col class="d-flex position-relative px-0" md="3">
                          <b-avatar
                            size="4rem"
                            v-if="assistant.user.avatarThumbnail"
                            :src="assistant.user.avatarThumbnail"
                            class="pa-avatar"
                          ></b-avatar>
                          <b-avatar
                            size="4rem"
                            v-else
                            class="pa-avatar bg--primary"
                            :text="assistant.assistantInitials"
                          ></b-avatar>
                        </b-col>
                        <b-col class="position-relative px-0 ml-3">
                          <h6
                            class="
                              font-sm font-family-medium
                              primary--text
                              mt-1
                              reduce-line-height
                            "
                          >
                            {{
                              assistant.assistantFullname.length > 20
                                ? `${assistant.assistantFullname.substring(
                                    0,
                                    20
                                  )}...`
                                : assistant.assistantFullname
                            }}
                          </h6>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="4" class="justify-content-left">
                      <h6
                        class="font-sm grid-list-progress-text align-self-start"
                      >
                        <!-- {{
                          `${assistant.assignedHours}/${assistant.availableHours}`
                        }} -->
                        5/10
                      </h6>
                      <!-- <b-progress
                        class="grid-list-progress"
                        height="0.5rem"
                        :value="assistant.assignedHours"
                        :max="assistant.availableHours"
                      ></b-progress> -->
                      <b-progress
                        class="grid-list-progress"
                        height="0.5rem"
                        :value="5"
                        :max="10"
                      ></b-progress>
                    </b-col>
                    <b-col
                      style="position: relative; top: 0.5rem"
                      md="2"
                      class="justify-content-left d-flex"
                    >
                      <h6
                        style="left: 1rem"
                        class="
                        font-sm font-family-medium 
                        position-relative 
                        primary--text 
                        text-center
                        "
                      >
                        {{
                          getAssistantJobTitle(
                            assistant.assistantProfile.jobTitle
                          )
                        }}
                      </h6>
                    </b-col>
                    <b-col
                      md="2"
                      style="left: 2.5rem"
                      class="
                        cy-assign-pa-checkbox-container
                        position-relative
                        justify-content-center
                        d-flex
                      "
                      data-cy="assign-pa-checkbox-container"
                    >
                      <b-form-group class="pt-3">
                        <b-form-checkbox
                          style="z-index: 0"
                          size="lg"
                          class="checkbox cy-assign-pa-checkbox"
                          data-cy="assign-pa-checkbox"
                          name="check"
                          @change="selectPA($event, index)"
                          v-model="selectedPA"
                          :value="assistant"
                        ></b-form-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
              </b-row>
            </div>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <b-modal
      centered
      body-class="assign-modal"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="showSelectionModal"
    >
      <b-container fluid>
        <b-button
          @click.prevent="backToForm2"
          v-if="!paLoading"
          class="d-flex position-absolute close-btn"
        >
          <img
            class="cy-assign-pa-modal-close close-icon"
            src="@/assets/icons/close_sidebar.svg"
            alt
          />
        </b-button>
        <b-row class="d-flex flex-column">
          <h2
            class="modal_header font-md"
            v-if="!success"
            :style="{ marginBottom: 0 }"
          >
            Are you sure?
          </h2>
          <h2 v-else 
            class="modal_header font-md"
            data-cy="pa-assign-success"
          >
            Successfully assigned
          </h2>
          <h4 v-if="!success" class="subtext font-md">
            Do you want to assign the following EA to the client?
          </h4>
          <h4 v-else class="subtext font-md">
            Following EA has been successfully assigned.
          </h4>
        </b-row>
        <b-row class="d-flex middle-row">
          <div class="avatar-wrapper">
            <b-avatar
              v-if="modalAvatar"
              :src="modalAvatar"
              size="8rem"
              class="pa-avatar"
            ></b-avatar>
            <b-avatar
              v-else
              class="bg--primary"
              :text="assistantInitial(selectedPAbody)"
              size="8rem"
            ></b-avatar>
          </div>
          <div class="info-wrapper">
            <p class="cy-assign-pa-name font-family-medium primary--text mt-2">
              {{ assistantFullName(selectedPAbody) }}
            </p>
            <p class="cy-assign-pa-email secondary--text reduce-whitespace">
              {{ selectedPAbody.user ? selectedPAbody.user.email : "" }}
            </p>
          </div>
          <div class="bar-wrapper">
            <div class="capacity-row">
              <h6 class="font-sm grid-list-progress-text capacity-text">
                Capacity
              </h6>
              <h6 class="font-sm grid-list-progress-text capacity-value">
                5/10
              </h6>
            </div>
            <b-progress
              class="grid-list-progress"
              height="0.5rem"
              :value="value"
              :max="max"
            ></b-progress>
          </div>
        </b-row>
        <b-row>
          <b-button
            v-if="!success"
            style="font-weight: normal"
            class="cy-assign-pa-confirm-btn px-5 py-3 btn-pill"
            @click.prevent="saveCustomer"
          >
            <b-spinner
              v-if="paLoading"
              style="width: 14px; height: 14px"
              variant="light"
              label="Spinning"
            ></b-spinner>
            {{ `${!paLoading ? "Yes, Assign" : ""}` }}
          </b-button>
          <b-button
            v-else
            style="font-weight: normal"
            class="cy-assign-pa-confirm-done-btn px-5 py-3 btn-pill"
            @click.prevent="backToForm"
          >
            Done
          </b-button>
        </b-row>
      </b-container>
    </b-modal>

    <b-modal
      centered
      class="modal-padding cy-assign-pa-modal"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="showSelectionModal2"
    >
      <b-container fluid v-if="!success">
        <b-button
          @click.prevent="backToForm2"
          v-if="!paLoading"
          class="d-flex position-absolute close-btn"
        >
          <img
            class="cy-assign-pa-modal-close close-icon"
            src="@/assets/icons/close_sidebar.svg"
            alt
          />
        </b-button>
        <b-row class="pt-2 pl-4 d-flex flex-column">
          <h4 
          class="font-md subtext mb-4 mt-3 cy-assign-pa-modal-header"
          data-cy="assign-pa-modal-header"
          >
            Do you want to assign the following EA to the Customer?
          </h4>
        </b-row>
        <b-row align-v="center">
          <b-col md="8" class="flex-row d-flex mb-4">
            <div>
              <b-avatar
                v-if="modalAvatar"
                :src="modalAvatar"
                size="8rem"
                class="pa-avatar"
              ></b-avatar>
              <b-avatar
                v-else
                class="bg--primary"
                :text="assistantInitial(selectedPAbody)"
                size="8rem"
              ></b-avatar>
            </div>
            <div
              class="
                d-flex
                flex-column
                justify-content-center
                position-relative
                ml-4
              "
            >
              <p
                class="cy-assign-pa-name font-family-medium primary--text mt-2"
              >
                {{ assistantFullName(selectedPAbody) }}
              </p>
              <p class="cy-assign-pa-email secondary--text reduce-whitespace">
                {{ selectedPAbody.user ? selectedPAbody.user.email : "" }}
              </p>
            </div>
          </b-col>
          <b-button
            style="font-weight: normal"
            class="
              cy-assign-pa-confirm-btn
              btn-primary
              px-5
              py-3
              btn-pill
              reduce-whitespace
              ml-4
            "
            @click.prevent="saveCustomer"
          >
            <b-spinner
              v-if="paLoading"
              style="width: 14px; height: 14px"
              variant="light"
              label="Spinning"
            ></b-spinner>
            {{ `${!paLoading ? "Yes, Assign" : ""}` }}
          </b-button>
        </b-row>
      </b-container>
      <b-container fluid v-else>
        <b-row class="pt-2 pl-4 d-flex flex-column">
          <h2 class="modal_header font-md ml-2 cy-assign-pa-success">
            EA assigned successfully
          </h2>
        </b-row>
        <b-row align-v="center" class="pr-2">
          <b-col md="9" class="flex-row d-flex mt-2 mb-4">
            <div>
              <b-avatar
                v-if="modalAvatar"
                :src="modalAvatar"
                size="8rem"
                class="pa-avatar"
              ></b-avatar>
              <b-avatar
                v-else
                class="bg--primary"
                :text="assistantInitial(selectedPAbody)"
                size="8rem"
              ></b-avatar>
            </div>
            <div
              class="
                d-flex
                flex-column
                justify-content-center
                position-relative
                ml-4
              "
            >
              <p
                class="
                  cy-assign-pa-name-success
                  font-family-medium
                  primary--text
                "
              >
                {{ assistantFullName(selectedPAbody) }}
              </p>
              <p
                class="
                  cy-assign-pa-email-success
                  secondary--text
                  reduce-whitespace
                "
              >
                {{ selectedPAbody.user ? selectedPAbody.user.email : "" }}
              </p>
            </div>
          </b-col>
          <b-button
            style="font-weight: normal"
            class="
              cy-assign-pa-done-btn
              btn-danger
              px-5
              py-3
              btn-pill
              reduce-whitespace
              mt-5
            "
            @click.prevent="backToForm"
          >
            Done
          </b-button>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal
      centered
      class="modal-padding"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="showRemovalModal"
    >
      <b-container fluid v-if="!success">
        <b-button
          @click.prevent="backToForm3"
          v-if="!paLoading"
          class="d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row class="pt-2 pl-4 d-flex flex-column">
          <h2 class="modal_header ml-2 font-md">Are you sure?</h2>
          <h4 class="font-md subtext mb-4 mt-3 ml-2">
            Do you want to remove the following EA from the customer?
          </h4>
        </b-row>
        <b-row align-v="center">
          <b-col md="9" class="flex-row d-flex">
            <div>
              <b-avatar
                v-if="modalAvatar"
                :src="modalAvatar"
                size="8rem"
                class="pa-avatar"
              ></b-avatar>
              <b-avatar
                v-else
                class="mb-4 mt-4 bg--primary"
                :text="assistantInitial(selectedPAbody)"
                size="8rem"
              ></b-avatar>
            </div>
            <div
              class="
                d-flex
                flex-column
                justify-content-center
                position-relative
                ml-4
              "
            >
              <p class="font-family-medium primary--text">
                {{ assistantFullName(selectedPAbody) }}
              </p>
              <p class="secondary--text reduce-whitespace">
                {{ selectedPAbody.user ? selectedPAbody.user.email : "" }}
              </p>
            </div>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-start mb-4">
          <b-button
            style="font-weight: normal"
            class="btn-danger px-5 py-3 btn-pill mt-3 ml-1 ar-x"
            @click.prevent="removeCustomer"
          >
            <b-spinner
              v-if="paLoading"
              style="width: 14px; height: 14px"
              variant="light"
              label="Spinning"
            ></b-spinner>
            {{ `${!paLoading ? "Yes, Remove" : ""}` }}
          </b-button>
        </div>
      </b-container>
      <b-container fluid v-else>
        <b-row class="pt-2 pl-4 d-flex flex-column">
          <h2 class="modal_header font-md ml-2">EA removed successfully</h2>
        </b-row>
        <b-row align-v="center">
          <b-col md="9" class="flex-row d-flex">
            <div>
              <b-avatar
                v-if="modalAvatar"
                :src="modalAvatar"
                size="8rem"
              ></b-avatar>
              <b-avatar
                v-else
                class="mb-4 mt-4 bg--primary"
                :text="assistantInitial(selectedPAbody)"
                size="8rem"
              ></b-avatar>
            </div>
            <div
              class="
                d-flex
                flex-column
                justify-content-center
                position-relative
                ml-4
              "
            >
              <p class="font-family-medium primary--text">
                {{ assistantFullName(selectedPAbody) }}
              </p>
              <p class="secondary--text reduce-whitespace">
                {{ selectedPAbody.user ? selectedPAbody.user.email : "" }}
              </p>
            </div>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-start mb-4">
          <b-button
            style="font-weight: normal"
            class="btn-danger px-5 py-3 btn-pill mt-3 ml-1 ar-x"
            @click.prevent="backToForm"
          >
            Done
          </b-button>
        </div>
      </b-container>
    </b-modal>
    <b-alert
      class="custom-alert-auth"
      :show="alertDuration"
      v-if="showAlert"
      :fade="true"
      >{{ msg }}</b-alert
    >
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from "vee-validate/dist/vee-validate.full";
import {
  assignPA,
  getCustomerCommunications,
  getCustomer,
  getSubmissions
} from "@/apis/customers";
import { getAssistantsList } from "@/apis/assistants";
import { deleteSelectedAssistants } from "@/apis/customers";
import { mapState } from "vuex";
import {
  profileTypes,
  subscriptionTypes,
  UNLIMITED,
  timeZones,
} from "@/utils/constants";
import { getAssistantJobTitle } from "@/utils/utils";

extend("email", {
  message: () => "Email is not valid"
});
extend("required", {
  message: () => "This is a required field"
});
export default {
  name: "AssignPA",
  components: {
    ValidationObserver,
    ValidationProvider
    // Multiselect
  },
  data() {
    return {
      employmentType: "",
      firstName: "",
      lastName: "",
      customerFullname: "",
      isLoadingCustomer: true,
      isLoadingAssistants: true,
      max: 10,
      value: 5,
      showListView: false,
      initials: [],
      pageLoading: false,
      assistantsList: [],
      paLoading: false,
      password: "",
      value2: "",
      phone: "",
      modalAvatar: "",
      avatar: "",
      // avatarName: "",
      emailPrimary: "",
      formatted: "",
      customerRole: "",
      selected: "",
      language: "",
      msg: "",
      variant: "",
      alertDuration: null,
      showAlert: false,
      showError: false,
      startDate: "",
      assignedPAid: "",
      emailSecondary: "",
      workHours: "",
      selectedPA: "",
      removedPA: "",
      selectedPAbody: {},
      removedPAbody: {},
      customerID: "",
      questions: [],
      infrastructure: "",
      success: false,
      linkedin: "",
      membership: null,
      formErrors: false,
      showSelectionModal: false,
      showRemovalModal: false,
      profileID: "",
      subscriptionPlan: subscriptionTypes,
      membershipHours: null,
      selectedProfileType: "",
      profileType: profileTypes,
      timeZone: timeZones,
      selectedTimeZone: null,
      dateOfJoining: "",
      customerInitials: "",
      showSelectionModal2: false,
      billingEntities: [
        { value: null, text: "Please select a Billing Entity" },
        { value: "EU", text: "Public Support Assistance BV (EU)" },
        { value: "US", text: "Public Support Assistance Services LLC (US)" }
      ],
      billingEntity: null
    };
  },
  mounted() {
    this.customerID = this.$route.params.id;
    getAssistantsList()
      .then(res => {
        this.assistantsList = [...res.data.results].map(item => {
          let { firstName, lastName } = item.user;
          item.assistantFullname = `${firstName} ${lastName}`;
          item.assistantInitials = item.assistantFullname
            .match(/\b(\w)/g)
            .join("");
          return item;
        });
      })
      .catch(err => {
        console.log(err);
        this.isLoadingAssistants = false;
      })
      .finally(() => {
        this.isLoadingAssistants = false;
      });
    getCustomer(this.customerID)
      .then(res => {
        let { profile, user, role } = res.data;
        this.selectedTimeZone = this.timeZone[profile.timezone.id + 1].text;
        this.language = profile.language;
        this.linkedin = profile.linkedin;
        profile.communicationManager.selectedMedium.map(item => {
          this.infrastructure += `${item.value}, `;
        });
        this.infrastructure = this.infrastructure.substring(
          0,
          this.infrastructure.length - 2
        );
        this.membership = profile.membership;
        this.membershipHours = profile.membershipHours;
        if (this.membership === UNLIMITED) {
          this.membershipHours = "N/A";
        }
        profile.profileType.selectedProfileTypes.map(item => {
          this.selectedProfileType += `${item.value}, `;
        });
        this.selectedProfileType = this.selectedProfileType.substring(
          0,
          this.selectedProfileType.length - 2
        );
        this.startDate = profile.startDate;
        this.profileID = profile.id;
        this.firstName = user.firstName;
        this.lastName = user.lastName;
        this.customerFullname = `${this.firstName} ${this.lastName}`;
        this.customerInitials = this.customerFullname.match(/\b(\w)/g).join("");
        this.emailPrimary = user.email;
        this.avatar = user.avatarThumbnail;
        this.customerRole = role.name;
        this.billingEntity = profile.billingEntity;
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        getCustomerCommunications(this.customerID)
          .then(res => {
            this.phone = [...res.data.results].filter(
              item => item.communication.order === 2
            )[0].value;
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.isLoadingCustomer = false;
          });
      });
    getSubmissions(this.$route.params.id)
      .then(res => {
        this.questions = [...res.data.results[0].submissions];
        this.questions.map(item => {
          if (
            item.formQuestion.question.questionType !== "TEXT" &&
            item.formQuestion.question.questionType !== "MULTILINE_TEXT"
          ) {
            let answer = [];
            item.answer.answer.map(item => {
              answer.push(item.title);
            });
            item.answer.answer = answer.join(", ");
          }
        });
      })
      .catch(err => {
        console.log(err);
      });
  },
  computed: {
    ...mapState("authModule", ["role"])
  },
  methods: {
    getAssistantJobTitle,
    navigateToCustomers() {
      if (this.role === "assistant") {
        this.$router.push({ name: "DedicatedCustomers" });
      } else if (this.role === "admin") {
        this.$router.push({
          name: "CustomersListAdmin",
          query: {
            tab: 0
          }
        });
      }
    },
    backToForm() {
      this.showSelectionModal = false;
      this.showRemovalModal = false;
      this.success = false;
      if (this.role === "admin") {
        this.$router.replace({
          name: "CustomersListAdmin",
          query: {
            tab: 0
          }
        });
      }
    },
    backToForm2() {
      this.selectedPA = "";
      this.success = false;
      this.showSelectionModal = false;
    },
    backToForm3() {
      this.selectedPA = this.removedPA;
      this.success = false;
      this.showRemovalModal = false;
    },
    removeCustomer() {
      this.paLoading = true;
      deleteSelectedAssistants(this.customerID, this.assignedPAid)
        .then(() => {
          this.paLoading = false;
          this.success = true;
          this.showAlert = true;
          this.alertDuration = 5;
          this.msg = "EA assigned!";
        })
        .catch(err => {
          console.log(err);
          this.paLoading = false;
          this.showRemovalModal = false;
          this.success = false;
          this.showAlert = true;
          this.alertDuration = 5;
          this.msg = "Some error Occured!";
        })
        .finally(() => {
          setTimeout(() => {
            this.showAlert = false;
          }, 5000);
        });
    },
    selectPA(checked, index) {
      if (!checked) {
        this.removedPA = this.assistantsList[index];
        this.removedPAbody = this.assistantsList[index];
        this.modalAvatar = this.removedPAbody?.user.avatarThumbnail;
        if (this.removedPA !== null) {
          this.showRemovalModal = true;
        }
      } else {
        this.selectedPAbody = checked;
        this.employmentType = this.selectedPAbody.assistantProfile.employment;
        this.modalAvatar = this.selectedPAbody?.user.avatarThumbnail;
        if (this.selectedPA !== null) {
          this.showSelectionModal = true;
        }
      }
    },
    saveCustomer() {
      this.paLoading = true;
      const assignPAData = {
        customer: this.customerID,
        assistant: this.selectedPAbody.id
      };
      assignPA(this.profileID, assignPAData)
        .then(res => {
          this.paLoading = false;
          this.assignedPAid = res.data.id;
          this.success = true;
          this.variant = "success";
          this.msg = "EA assigned!";
        })
        .catch(err => {
          console.log(err);
          this.paLoading = false;
          this.showSelectionModal = false;
          this.success = false;
          this.showAlert = true;
          this.alertDuration = 5;
          this.variant = "danger";
          this.msg = "Some error Occured!";
        })
        .finally(() => {
          setTimeout(() => {
            this.showAlert = false;
          }, 5000);
        });
    },
    workHoursToInteger(work_hours) {
      return Number(work_hours);
    },
    assistantFullName(profile) {
      return `${profile?.user?.firstName} ${profile?.user?.lastName}`;
    },
    assistantInitials(user) {
      return `${user?.firstName
        ?.charAt(0)
        .toUpperCase()}${user?.lastName?.charAt(0).toUpperCase()}`;
    },
    assistantInitial(profile) {
      return `${profile?.user?.firstName
        ?.charAt(0)
        .toUpperCase()}${profile?.user?.lastName.charAt(0).toUpperCase()}`;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";
.questions-list:last-child {
  margin-bottom: 0rem;
}
.questions-list:not(:last-child) {
  margin-bottom: 3rem;
}
.full-bg {
  height: 100% !important;
}
.user-info-right {
  right: 0;
  top: 1rem;
}
.user-avatar-right-container {
  width: 64px;
  height: 64px;
}
.pa-avatar-container {
  width: 36px;
  height: 36px;
}
.user-info-content {
  left: 0;
}
.general-info-form-group {
  flex: 0 0 50%;
}
.general-info-card {
  padding: 0rem 0.5rem 0.5rem 0.5rem;
}
.communication-icons {
  width: 40px;
  height: 40px;
}
.communication-icons img {
  object-fit: cover;
  width: inherit;
  position: relative;
  bottom: 0rem;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
::v-deep .assign-modal.modal-body {
  padding: 2.5rem;
  h4.subtext {
    // padding-bottom: 2.5rem;
  }
  .middle-row {
    padding: 3rem 0;
  }
  .avatar-wrapper {
    // flex: 1;
    padding-right: 20px;
  }
  .info-wrapper {
    flex: 3;
  }
  .bar-wrapper {
    flex: 2;
    .capacity-row {
      display: flex;
      .capacity-value {
        margin-left: auto;
      }
    }
  }
  button.is-danger {
    background-color: $danger;
  }
}
select.custom-select {
  line-height: 1 !important;
  color: unset;
}
</style>
